import { IframeQueryParameters } from '@wix/wix-chatbot-common/browser';
import React, { FC } from 'react';
import { useSelector, useStore } from 'react-redux';
import { Navigate, To, useSearchParams } from 'react-router-dom';

import { Chatbot } from '../../chatbot';
import { Loader } from '../../common/components/Loader';
import { useAnimation } from '../../common/hooks/useAnimation';
import { selectChatbotDataLoading } from '../../common/selectors/chat';
import { homepageService } from '../../common/services/homepage/homepageService';
import { appRoutes } from '../../react-router';
import { classNames } from '../../util';
import s from './styles.scss';

export const ChatbotPage: FC = () => {
  const store = useStore();
  const [searchParams] = useSearchParams();
  const chatbotDataLoading = useSelector(selectChatbotDataLoading);
  const activeAnimation = useAnimation(s.moveInRight, s.moveInLeft, []);

  if (!homepageService.homepageEnabled) {
    // if homepage is not enabled we use ChatbotSlider to show Chatbot component(not a separate page).
    // So we need to redirect to previous route and set isChatbotOpen to true(to show chatbot slider instead of separate page)
    searchParams.set(IframeQueryParameters.isChatbotOpen, 'true');

    const redirectTo: To = {
      pathname: appRoutes.categories(),
      search: searchParams.toString(),
    };
    return <Navigate to={redirectTo} replace />;
  }

  if (chatbotDataLoading) {
    return (
      <Loader
        height="100%"
        width="100%"
        verticalAlign="middle"
        backgroundColor="D70"
      />
    );
  }

  return (
    <div className={classNames([s.chatbotContainer, activeAnimation])}>
      <Chatbot store={store} isOpen={true} />
    </div>
  );
};
